import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { getDescendants, NodeModel } from "@minoru/react-dnd-treeview";
import styles from "./styles.module.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Menu, MenuItem, Stack } from "@mui/material";
import { useTranslations } from "next-intl";
import { useTheme } from "@quales/utils/theme";
const TREE_X_OFFSET = 22;

const Node: React.FC<{
  node: NodeModel;
  depth: number;
  isOpen: boolean;
  isSelected?: boolean;
  isDropTarget: boolean;
  treeData: NodeModel[];
  onClick: (id: NodeModel["id"]) => void;
  onTreeItemClick: (id: NodeModel["id"]) => void;
  onAddButtonClicked: (id: NodeModel["id"], type: string) => void;
  onContentCopyClicked: (node: NodeModel) => void;
  getPipeHeight: (id: string | number, treeData: NodeModel[]) => number;
}> = ({
  node,
  depth,
  isOpen,
  isDropTarget,
  onClick,
  onTreeItemClick,
  treeData,
  getPipeHeight,
  isSelected,
  onAddButtonClicked,
  onContentCopyClicked,
}) => {
  const indent = depth * TREE_X_OFFSET;

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(node.id);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const theme = useTheme();

  const t = useTranslations();
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handelMenuItemClicked = (item: string) => {
    onAddButtonClicked(node.id, item);
    setAnchorEl(null);
  };

  const handleCopyClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onContentCopyClicked(node);
  };

  const handleItemClicked = (e: React.MouseEvent) => {
    e.stopPropagation();

    onTreeItemClick(node.id);
  };

  return (
    <div
      className={`${styles.nodeWrapper} tree-node ${
        node.droppable && isDropTarget ? styles.dropTarget : ""
      }`}
      style={{
        marginInlineStart: indent,
        backgroundColor: isSelected ? theme.appColors.surfaceTint : "",
        color: isSelected ? theme.appColors.onSecondary : "",
      }}
    >
      <div
        className={`${styles.expandIconWrapper} ${isOpen ? styles.isOpen : ""}`}
        onClick={handleToggle}
      >
        {node.droppable && (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5866 5.99969L7.99997 8.58632L5.41332 5.99969C5.15332 5.73969 4.73332 5.73969 4.47332 5.99969C4.21332 6.25969 4.21332 6.67965 4.47332 6.93965L7.5333 9.99965C7.59497 10.0615 7.66823 10.1105 7.7489 10.144C7.82957 10.1775 7.91603 10.1947 8.0033 10.1947C8.09063 10.1947 8.1771 10.1775 8.25777 10.144C8.33837 10.1105 8.41163 10.0615 8.4733 9.99965L11.5333 6.93965C11.7933 6.67965 11.7933 6.25969 11.5333 5.99969C11.2733 5.74635 10.8466 5.73969 10.5866 5.99969Z"
              fill="black"
            />
          </svg>
        )}
      </div>
      <div
        className={styles.pipeX}
        style={{ width: depth > 0 ? TREE_X_OFFSET - 9 : 0 }}
      />
      {getDescendants(treeData, node.parent)[0].id === node.id && (
        <div
          className={styles.pipeY}
          style={{
            height: Math.max(0, getPipeHeight(node.parent, treeData) - 8),
          }}
        />
      )}
      <div onClick={handleItemClicked} className={styles.labelGridItem}>
        {node.text}
      </div>
      <Stack direction={"row"}>
        {
          //@ts-ignore
          node && node.type && node.type === "object" && depth !== 2 && (
            <div onClick={handleClick}>
              <AddIcon color={isSelected ? "action" : "primary"} />
            </div>
          )
        }

        {
          //@ts-ignore
          node && node.type && node.id !== "root" && depth < 3 && (
            <div onClick={handleCopyClick}>
              <ContentCopyIcon color={isSelected ? "action" : "primary"} />
            </div>
          )
        }
      </Stack>

      <Menu
        id="addItem-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => handelMenuItemClicked("text")}>
          {t("labels.text")}
        </MenuItem>
        <MenuItem onClick={() => handelMenuItemClicked("object")}>
          {t("labels.object")}
        </MenuItem>

        <MenuItem onClick={() => handelMenuItemClicked("boolean")}>
          {t("labels.boolean")}
        </MenuItem>
        <MenuItem onClick={() => handelMenuItemClicked("array")}>
          {t("labels.array")}
        </MenuItem>
        <MenuItem onClick={() => handelMenuItemClicked("image")}>
          {t("labels.image")}
        </MenuItem>
        <MenuItem onClick={() => handelMenuItemClicked("listOfStrings")}>
          {t("labels.listOfStrings")}
        </MenuItem>
        <MenuItem onClick={() => handelMenuItemClicked("signature")}>
          {t("labels.signature")}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default Node;
